type SetDefinition = Models.SetsPlayground.SetDefinition;
type SetDistribution = Models.SetsPlayground.SetDistribution;
type AllocatedDistribution = Extract<SetDistribution, { type: 'probability' | 'backpressure' }>;

const ALLOCATED_DISTRIBUTION_TYPES: ReadonlySet<SetDistribution['type']> = new Set(['probability', 'backpressure']);

const isAllocatedDistribution = (
    distribution: SetDistribution | null | undefined,
): distribution is AllocatedDistribution => !!distribution && ALLOCATED_DISTRIBUTION_TYPES.has(distribution.type);

const roundShare = (share: number): number => Math.round(share * 10000) / 10000;

export interface CultureGroupAllocation {
    sets: SetDefinition[];
    newnessEnabled: boolean;
    newnessDistribution: SetDistribution | null | undefined;
}

export const calculateAllocatedShare = ({
    sets,
    newnessEnabled,
    newnessDistribution,
}: CultureGroupAllocation): number => {
    const setsShare = sets.reduce((total, set) => (
        isAllocatedDistribution(set.distribution) ? total + set.distribution.part : total
    ), 0);

    const newnessShare = newnessEnabled && isAllocatedDistribution(newnessDistribution)
        ? newnessDistribution.part
        : 0;

    return roundShare(setsShare + newnessShare);
};
